/*
 *
 * Home actions
 *
 */

import {
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_WATCHER,
  GET_COMPANIES_FAILED,
  GET_COMPANIES_INFO_SUCCESS,
  GET_COMPANIES_INFO_WATCHER,
  SEARCH_FAILED,
  SEARCH_SUCCESS,
  SEARCH_WATCHER,
  GO_COMPANY_WATCHER,
} from "./constants"

export function getCompaniesWatcher(payload) {
  return {
    type: GET_COMPANIES_WATCHER,
    payload,
  }
}

export function getCompaniesSuccess(payload) {
  return {
    type: GET_COMPANIES_SUCCESS,
    payload,
  }
}

export function getCompaniesFailed() {
  return { type: GET_COMPANIES_FAILED }
}

export function getCompaniesInfoWatcher(payload) {
  return {
    type: GET_COMPANIES_INFO_WATCHER,
    payload,
  }
}

export function getCompaniesInfoSuccess(payload) {
  return {
    type: GET_COMPANIES_INFO_SUCCESS,
    payload,
  }
}

export function searchWatcher(payload) {
  return {
    type: SEARCH_WATCHER,
    payload,
  }
}

export function searchSuccess(payload) {
  return {
    type: SEARCH_SUCCESS,
    payload,
  }
}

export function searchFailed() {
  return { type: SEARCH_FAILED }
}

export function goCompanyWatcher(payload) {
  return {
    type: GO_COMPANY_WATCHER,
    payload,
  }
}
